<div class="mct-flex mct-row mct-justify-between mct-items-center">
  <span class="title-header mb-27">{{ 'profiles.contact-records.header' | translate | titlecase }}</span>
</div>

<div class="params-container mb-20">
  <div class="search-header mb-32">{{ 'profiles.contact-records.search-contact-records' | translate | titlecase }}</div>
  <wl-contact-record-search-params #searchParamsComp [searchParams]="searchParams"></wl-contact-record-search-params>
  <div class="mt-33 mct-flex mct-row mct-justify-end mct-items-center">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.searchFromSearchParamsComponent()">
      {{ 'profiles.contact-records.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>

<div class="divider-bar mb-21 mct-flex mct-row">
  <button pButton type="button" class="mct-flex ml-10 atlas-btn atlas-btn-primary mct-justify-start mct-items-stretch" type="button" (click)="export()">
    Export
  </button>
  <div class="mct-flex mct-justify-end mct-items-center contact-records-95pct">
    <span *ngIf="!contactRecordSearchResult?.TotalCount; else resultsReturned" class="no-results">
      {{ 'web-content.search-grid.no-search-results' | translate | ucfirst }}
    </span>
    <ng-template #resultsReturned>
      <span>{{ 'profiles.contact-records.the-search-returned' | translate | ucfirst }}</span>
      &nbsp;
      <span class="f-wb">{{ contactRecordSearchResult.TotalCount }}</span>
      &nbsp;
      <span class="f-wb">{{ 'profiles.contact-records.contact-records' | translate }}</span>
    </ng-template>
    <button
      class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center"
      type="button"
      (click)="clear()"
      (click)="searchParamsComp.clearSelectedContactTypes()"
      (click)="searchGrid.clearSearchResults()"
    >
      <i class="large-icon pi pi-times"></i>
      <span class="ml-5">{{ 'profiles.contact-records.clear-search' | translate | uppercase }}</span>
    </button>
  </div>
</div>

<wl-contact-record-search-grid
  #searchGrid
  [searchParams]="searchParams"
  (completedSearch)="contactRecordSearchResult = $event"
></wl-contact-record-search-grid>
